import { Component, Prop, Vue } from 'vue-property-decorator';
import retry from '@/helpers/retry';
@Component({ components: {} })
export default class MobileFooterPortal extends Vue {
    @Prop({ default: 'has-mobile-footer' })
    className;
    resizeObserver;
    mounted() {
        const body = document.body;
        body.classList.add(this.className);
        let footerEl = null;
        if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => {
                if (!footerEl) {
                    footerEl = this.getFooterEl();
                }
                this.updateMobileFooterHeightCssProp(footerEl?.offsetHeight);
            });
        }
        const stop = retry(() => {
            const footer = this.getFooterEl();
            if (footer) {
                this.resizeObserver?.observe(footer);
                this.updateMobileFooterHeightCssProp();
                stop();
            }
        });
    }
    getFooterEl() {
        // Do not use `this.$refs` to get the `.mobile-footer` element because
        // it's in a portal. It required double `$nextTick` to work
        // (https://portal-vue.linusb.org/guide/caveats.html#refs)
        return document.querySelector('.mobile-footer');
    }
    /**
     * Update `--mobile-footer-height` CSS var. If height argument is provided
     * then use it, otherwise query the height from `.mobile-footer` element.
     */
    updateMobileFooterHeightCssProp(height) {
        if (!height) {
            // Use `document.querySelector` instead of Vue ref as a ref's not ready
            // when a user added the first item to the cart
            const footer = this.getFooterEl();
            height = footer?.offsetHeight ?? 80;
        }
        document.documentElement.style.setProperty('--mobile-footer-height', `${height}px`);
    }
    destroyed() {
        document.body.classList.remove(this.className);
        this.resizeObserver?.disconnect();
    }
}
